import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation resources
const resources = {
  en: {
    translation: {
      // Common
      'common.save': 'Save',
      'common.cancel': 'Cancel',
      'common.delete': 'Delete',
      'common.edit': 'Edit',
      'common.create': 'Create',
      'common.update': 'Update',
      'common.search': 'Search',
      'common.loading': 'Loading...',
      'common.error': 'Error',
      'common.success': 'Success',
      
      // Navigation
      'nav.dashboard': 'Dashboard',
      'nav.products': 'Products',
      'nav.categories': 'Categories',
      'nav.orders': 'Orders',
      'nav.users': 'Users',
      'nav.hero': 'Hero',
      'nav.blog': 'Blog',
      'nav.reels': 'Reels',
      'nav.messages': 'Messages',
      'nav.newsletter': 'Newsletter',
      'nav.promocodes': 'Promocodes',
      'nav.settings': 'Settings',
      
      // Auth
      'auth.login': 'Login',
      'auth.logout': 'Logout',
      'auth.email': 'Email',
      'auth.password': 'Password',
      'auth.loginSuccess': 'Login successful',
      'auth.loginError': 'Login failed',
      
      // Dashboard
      'dashboard.title': 'Dashboard',
      'dashboard.totalOrders': 'Total Orders',
      'dashboard.totalRevenue': 'Total Revenue',
      'dashboard.totalProducts': 'Total Products',
      'dashboard.totalUsers': 'Total Users',
      'dashboard.recentOrders': 'Recent Orders',
      'dashboard.topProducts': 'Top Products',
      
      // Products
      'products.title': 'Products',
      'products.create': 'Create Product',
      'products.edit': 'Edit Product',
      'products.name': 'Product Name',
      'products.name_ro': 'Name (Romanian)',
      'products.description': 'Description',
      'products.description_en': 'Description (English)',
      'products.description_ro': 'Description (Romanian)',
      'products.price': 'Price',
      'products.quantity': 'Quantity',
      'products.category': 'Category',
      'products.status': 'Status',
      'products.images': 'Images',
      'products.mainImage': 'Main Image',
      'products.additionalImages': 'Additional Images',
      'products.video': 'Video',
      'products.characteristics': 'Characteristics',
      
      // Categories
      'categories.title': 'Categories',
      'categories.create': 'Create Category',
      'categories.edit': 'Edit Category',
      'categories.name': 'Category Name',
      'categories.image': 'Category Image',
      'categories.slug': 'Slug',
      
      // Orders
      'orders.title': 'Orders',
      'orders.status': 'Status',
      'orders.total': 'Total',
      'orders.customer': 'Customer',
      'orders.date': 'Date',
      'orders.pending': 'Pending',
      'orders.paid': 'Paid',
      'orders.shipped': 'Shipped',
      'orders.cancelled': 'Cancelled',
      
      // Users
      'users.title': 'Users',
      'users.name': 'Name',
      'users.email': 'Email',
      'users.role': 'Role',
      'users.admin': 'Admin',
      'users.user': 'User',
      'users.lastLogin': 'Last Login',
      
      // File Upload
      'upload.dragDrop': 'Drag & drop files here or click to browse',
      'upload.maxSize': 'Max file size: {{size}}MB',
      'upload.selectedFiles': 'Selected files',
      
      // Status
      'status.active': 'Active',
      'status.inactive': 'Inactive',
      'status.published': 'Published',
      'status.draft': 'Draft',
      
      // Actions
      'actions.view': 'View',
      'actions.edit': 'Edit',
      'actions.delete': 'Delete',
      'actions.confirmDelete': 'Are you sure you want to delete this item?',
    }
  },
  ro: {
    translation: {
      // Common
      'common.save': 'Salvează',
      'common.cancel': 'Anulează',
      'common.delete': 'Șterge',
      'common.edit': 'Editează',
      'common.create': 'Creează',
      'common.update': 'Actualizează',
      'common.search': 'Caută',
      'common.loading': 'Se încarcă...',
      'common.error': 'Eroare',
      'common.success': 'Succes',
      
      // Navigation
      'nav.dashboard': 'Panou de control',
      'nav.products': 'Produse',
      'nav.categories': 'Categorii',
      'nav.orders': 'Comenzi',
      'nav.users': 'Utilizatori',
      'nav.hero': 'Hero',
      'nav.blog': 'Blog',
      'nav.reels': 'Reels',
      'nav.messages': 'Mesaje',
      'nav.newsletter': 'Newsletter',
      'nav.promocodes': 'Coduri promo',
      'nav.settings': 'Setări',
      
      // Auth
      'auth.login': 'Autentificare',
      'auth.logout': 'Deconectare',
      'auth.email': 'Email',
      'auth.password': 'Parolă',
      'auth.loginSuccess': 'Autentificare reușită',
      'auth.loginError': 'Autentificare eșuată',
      
      // Dashboard
      'dashboard.title': 'Panou de control',
      'dashboard.totalOrders': 'Total Comenzi',
      'dashboard.totalRevenue': 'Venit Total',
      'dashboard.totalProducts': 'Total Produse',
      'dashboard.totalUsers': 'Total Utilizatori',
      'dashboard.recentOrders': 'Comenzi Recente',
      'dashboard.topProducts': 'Produse Populare',
      
      // Products
      'products.title': 'Produse',
      'products.create': 'Creează Produs',
      'products.edit': 'Editează Produs',
      'products.name': 'Nume Produs',
      'products.description': 'Descriere',
      'products.description_en': 'Descriere (Engleză)',
      'products.description_ro': 'Descriere (Română)',
      'products.price': 'Preț',
      'products.quantity': 'Cantitate',
      'products.category': 'Categorie',
      'products.status': 'Status',
      'products.images': 'Imagini',
      'products.mainImage': 'Imagine Principală',
      'products.additionalImages': 'Imagini Adiționale',
      'products.video': 'Video',
      'products.characteristics': 'Caracteristici',
      
      // Categories
      'categories.title': 'Categorii',
      'categories.create': 'Creează Categorie',
      'categories.edit': 'Editează Categorie',
      'categories.name': 'Nume Categorie',
      'categories.name_ro': 'Nume (Română)',
      'categories.image': 'Imagine Categorie',
      'categories.slug': 'Slug',
      
      // Orders
      'orders.title': 'Comenzi',
      'orders.status': 'Status',
      'orders.total': 'Total',
      'orders.customer': 'Client',
      'orders.date': 'Data',
      'orders.pending': 'În așteptare',
      'orders.paid': 'Plătită',
      'orders.shipped': 'Expediată',
      'orders.cancelled': 'Anulată',
      
      // Users
      'users.title': 'Utilizatori',
      'users.name': 'Nume',
      'users.email': 'Email',
      'users.role': 'Rol',
      'users.admin': 'Administrator',
      'users.user': 'Utilizator',
      'users.lastLogin': 'Ultima autentificare',
      
      // File Upload
      'upload.dragDrop': 'Trageți și plasați fișierele aici sau faceți clic pentru a naviga',
      'upload.maxSize': 'Dimensiune maximă: {{size}}MB',
      'upload.selectedFiles': 'Fișiere selectate',
      
      // Status
      'status.active': 'Activ',
      'status.inactive': 'Inactiv',
      'status.published': 'Publicat',
      'status.draft': 'Ciornă',
      
      // Actions
      'actions.view': 'Vezi',
      'actions.edit': 'Editează',
      'actions.delete': 'Șterge',
      'actions.confirmDelete': 'Sigur doriți să ștergeți acest element?',
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
